import type { ComponentType, SVGProps } from "react";

export type FinalizeApi = "NONE" | "FEDEX" | "NONE_SIMPLIFIED";
export enum FinalizeApiEnum {
  NONE = "NONE",
  FEDEX = "FEDEX",
  NONE_SIMPLIFIED = "NONE_SIMPLIFIED",
}

/** Labels for the expedition header API select (dropdown row + closed trigger). */
export type FinalizeApiHeaderSelectLabels = {
  /** Row text in the menu; FedEx logo is shown after this text when applicable. */
  optionLabel: string;
  /** Trigger text; FedEx logo is shown before this text when applicable. */
  triggerLabel: string;
};

export type FinalizeApiOption = {
  value: FinalizeApi;
  /** Radio label in the finalize expedition modal */
  label: string;
  headerSelect: FinalizeApiHeaderSelectLabels;
  Icon?: ComponentType<SVGProps<SVGSVGElement>>;
};
